import { n as a } from "./_plugin-vue2_normalizer.b18b0e0b.js";
const o = "cookieSetting", n = "cookieSettingExpireAt", c = ["\u0E44\u0E17\u0E22", "EN"], r = {
  bannerBody: {
    \u0E44\u0E17\u0E22: "\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E43\u0E0A\u0E49\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E14\u0E35\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C \u0E42\u0E14\u0E22\u0E40\u0E23\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E17\u0E48\u0E32\u0E19\u0E40\u0E02\u0E49\u0E32\u0E21\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E48\u0E32\u0E19\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48",
    EN: "This website uses cookies to improve your online experience. They were placed on your browser when you launched this website. You can read more detail by clicking"
  },
  popupBody: {
    \u0E44\u0E17\u0E22: "\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1B\u0E34\u0E14\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23\u0E01\u0E47\u0E15\u0E32\u0E21 \u0E17\u0E48\u0E32\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1A\u0E25\u0E47\u0E2D\u0E04\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E0B\u0E36\u0E48\u0E07\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E44\u0E14\u0E49 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E48\u0E32\u0E19\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48",
    EN: "These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information. You can read more detail by clicking Cookie Policy"
  },
  policyLink: {
    \u0E44\u0E17\u0E22: "\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49",
    EN: "Cookie Policy"
  },
  acceptAll: {
    \u0E44\u0E17\u0E22: "\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    EN: "Accept all"
  },
  setting: {
    \u0E44\u0E17\u0E22: "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49",
    EN: "Cookie setting"
  },
  save: {
    \u0E44\u0E17\u0E22: "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
    EN: "Save setting"
  }
}, l = {
  name: "wv-cookie-banner",
  props: {
    cookieOptions: {},
    daysToExpire: { default: 30 },
    onAccept: {},
    policyUrl: {}
  },
  data: () => ({
    activeLang: "\u0E44\u0E17\u0E22",
    isShow: !1,
    isSettingOpen: !1,
    selectedCookies: {},
    langs: c,
    translation: r
  }),
  mounted() {
    var E;
    const t = localStorage.getItem(
      o
    ), u = localStorage.getItem(
      n
    );
    t && u && new Date().getTime() < new Date(+u).getTime() ? (E = this.onAccept) == null || E.call(this, JSON.parse(t)) : (localStorage.removeItem(o), localStorage.removeItem(n), this.isShow = !0);
  },
  methods: {
    createCookieSetting(t) {
      return this.cookieOptions ? this.cookieOptions.reduce(
        (u, E) => ({
          ...u,
          [E]: t
        }),
        {}
      ) : {};
    },
    openSetting() {
      this.selectedCookies = this.createCookieSetting(!1), this.isSettingOpen = !0;
    },
    save(t) {
      var E;
      const u = new Date().getTime() + this.daysToExpire * 24 * 60 * 60 * 1e3;
      localStorage.setItem(o, JSON.stringify(t)), localStorage.setItem(n, `${u}`), (E = this.onAccept) == null || E.call(this, t), this.isShow = !1;
    },
    _classStringToObject(t) {
      const u = {};
      if (typeof t != "string")
        return u;
      const E = t.trim().split(/\s+/);
      for (const e of E)
        u[e] = !0;
      return u;
    }
  }
};
var v = function() {
  var u = this, E = u._self._c;
  return u.isShow ? E("div", { class: u._classStringToObject(
    `wv_cookie-consent wv_cookie-consent--${u.isSettingOpen ? "popup" : "banner"}`
  ) }, [u.isSettingOpen ? [E("button", { staticClass: "wv_cookie-consent__close", on: { click: function(e) {
    u.isSettingOpen = !1;
  } } }, [E("svg", { attrs: { width: "13", height: "13", viewBox: "0 0 13 13" } }, [E("rect", { attrs: { x: "13", y: "1.41431", width: "15", height: "2", transform: "rotate(135 13 1.41431)", fill: "white" } }), E("rect", { attrs: { x: "2.39355", y: "0.0314941", width: "15", height: "2", transform: "rotate(45 2.39355 0.0314941)", fill: "white" } })])])] : u._e(), E("div", { staticClass: "wv_cookie-consent__container wv-font-baijamjuri" }, [E("div", { staticClass: "wv_cookie-consent__lang wv-b7" }, u._l(u.langs, function(e, i) {
    return E("button", { key: e, class: u._classStringToObject(
      `wv-font-baijamjuri ${u.activeLang === e ? "" : "inactive"}`
    ), on: { click: function(s) {
      u.activeLang = e;
    } } }, [u._v(" " + u._s(e) + " ")]);
  }), 0), u.isSettingOpen ? [E("div", { staticClass: "wv_cookie-consent__options wv-font-bold" }, [E("h2", { staticClass: "wv-b3" }, [u._v(u._s(u.translation.setting[u.activeLang]))]), E("div", [E("input", { attrs: { type: "checkbox", id: "cookie-necessary", disabled: !0 }, domProps: { checked: !0 } }), E("label", { attrs: { htmlFor: "cookie-necessary" } }, [u._v(" Strictly Necessary Cookies ")])]), u._l(u.cookieOptions, function(e, i) {
    return E("div", { key: e }, [E("input", { attrs: { type: "checkbox", id: `cookie-${e.toLowerCase()}` }, domProps: { checked: u.selectedCookies[e] }, on: { input: function(s) {
      u.selectedCookies = {
        ...u.selectedCookies,
        [e]: s.target.checked
      };
    } } }), E("label", { attrs: { htmlFor: `cookie-${e.toLowerCase()}` } }, [u._v(" " + u._s(e) + " " + u._s(" ") + "Cookies ")])]);
  })], 2)] : u._e(), E("div", { staticClass: "wv_cookie-consent__body wv-b5" }, [u._v(" " + u._s(u.translation[u.isSettingOpen ? "popupBody" : "bannerBody"][u.activeLang]) + u._s(" ") + " "), E("a", { attrs: { target: "_blank", href: u.policyUrl } }, [u._v(" " + u._s(u.translation.policyLink[u.activeLang]) + " ")])]), E("div", { staticClass: "wv_cookie-consent__actions wv-u2" }, [u.isSettingOpen ? [E("button", { staticClass: "wv-font-anuphan", on: { click: function(e) {
    return u.save(u.selectedCookies);
  } } }, [u._v(" " + u._s(u.translation.save[u.activeLang]) + " ")])] : [E("button", { staticClass: "wv-font-anuphan", on: { click: function(e) {
    return u.openSetting();
  } } }, [u._v(" " + u._s(u.translation.setting[u.activeLang]) + " ")])], E("button", { staticClass: "wv-font-anuphan", on: { click: function(e) {
    u.save(u.createCookieSetting(!0));
  } } }, [u._v(" " + u._s(u.translation.acceptAll[u.activeLang]) + " ")])], 2)], 2)], 2) : u._e();
}, _ = [], g = /* @__PURE__ */ a(
  l,
  v,
  _,
  !1,
  null,
  null,
  null,
  null
);
const k = g.exports;
export {
  k as default
};
